import React from 'react';
import { View } from 'react-native';

import { RectangleLoader } from '../../../Components/Loader';
import themeStyle from '../../../Theme/styles';

import StoreTagsLoader from '../../ReservationStoreDetails/StoreTagsLoader';

const StoreAndTagsLoader = (props: { [key: string]: any }) => {
  return (
    <View {...props}>
      <View style={themeStyle.spacingBottomSmall}>
        <RectangleLoader width="85%" height={39} />
      </View>
      <StoreTagsLoader category="s1" />
    </View>
  );
};

export default StoreAndTagsLoader;
